"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.commonAccent02 = exports.commonAccent01 = exports.commonInfo = exports.commonWarning = exports.commonError = exports.commonSuccess = exports.commonGradients = exports.commonBackgroundColors = exports.commonLightBackgroundColors = exports.commonTextColors = exports.commonNeutrals = void 0;
/* ⚠️⚠️⚠️ DANGER ZONE ⚠️⚠️⚠️ DANGER ZONE ⚠️⚠️⚠️ DANGER ZONE ⚠️⚠️⚠️
 * Changing shared code can have unintended consequences for all brands.
 * Please double check with the team before making changes here.
 * If brand specific changes are needed, they should be made in the brand's theme file.
 */
exports.commonNeutrals = {
    white: '#FFFFFF',
    '100': '#F2F3F4',
    '300': '#D6D9DA',
    '700': '#A7ADB0',
    '800': '#696E72',
    '900': '#434A4F',
};
exports.commonTextColors = {
    light: '#FFFFFF',
    disabled: '#A7ADB0',
    tertiary: '#696E72',
    secondary: '#434A4F',
    primary: '#002855',
    interactive: '#004BB9',
};
exports.commonLightBackgroundColors = {
    default: '#FFFFFF',
    paper: '#FFFFFF',
    light: '#E5F2FF',
    white: '#FFFFFF',
    neutral: '#F2F3F4',
    transparent: 'transparent',
};
exports.commonBackgroundColors = __assign(__assign({}, exports.commonLightBackgroundColors), { dark: '#002855' });
exports.commonGradients = {
    neutralGradient: 'linear-gradient(137.21deg, #EEEFF0 20.78%, #F5F6F7 90.43%)',
    darkGradient: 'linear-gradient(165.04deg, #0C3867 4.91%, #125399 89.46%)',
    yellowGradient: 'linear-gradient(180deg, #FCDE97 0%, #FACD64 100%)',
    pinkGradient: 'linear-gradient(180deg, #F291AD 0%, #D96297 100%)',
    tealGradient: 'linear-gradient(180deg, #77D7D9 0%, #4B9DA6 100%)',
    darkBlueGradient: 'linear-gradient(180deg, #0D294D 0%, #091B33 100%)',
};
exports.commonSuccess = {
    '300': '#E0F5E5',
    '500': '#A4E2B4',
    '700': '#027D5E',
};
exports.commonError = {
    '300': '#FEEAEA',
    '500': '#F1BFBF',
    '700': '#CF2A2A',
};
exports.commonWarning = {
    '300': '#FFEC9F',
    '500': '#FFD96A',
    '700': '#806310',
};
exports.commonInfo = {
    '300': '#E5F2FF',
    '500': '#B9DEFA',
    '700': '#004BB9',
};
exports.commonAccent01 = {
    '300': '#C8FAEF',
    '500': '#18D9AB',
    '700': '#16C39A',
};
exports.commonAccent02 = {
    '300': '#D6E6E8',
    '500': '#31808D',
    '700': '#276671',
};
